import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { HttpClient } from '@angular/common/http';

/**
 * Generated class for the HomeDashboardReservationsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-home-dashboard-addon-pro',
  templateUrl: 'home-dashboard-addon-pro.html',
})
export class HomeDashboardAddonPro {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient) {


  }

  fontStyleColor() {
    let cssClasses = {
      'mdi mdi-check': true,
      'font-color-no-addon': false,
      'font-color-addon': true,
    }
    return cssClasses;
  }

  payAddon() {
    //link a wordpress
    this.globals.openLandingPricing();
  }

  show_more: boolean = false;

  showMore(value) {
    this.show_more = value;
  }




}



// WEBPACK FOOTER //
// ./src/pages/home/home-dashboard/home-dashboard-addon-pro/home-dashboard-addon-pro.ts